<template>
    <div class="deposito-display d-flex align-center mr-4">
        <v-icon :size="depositoNombre ? 20 : 18" class="mr-2" :color="depositoNombre ? 'white' : 'warning'">
            {{ depositoNombre ? 'mdi-warehouse' : 'mdi-alert-circle' }}
        </v-icon>
        <div 
            class="deposito-badge" 
            :class="{ 'warning-badge': !depositoNombre, 'selected-badge': depositoNombre }"
        >
            <span class="deposito-label">depósito:</span>
            <span class="deposito-value">
                {{ depositoNombre || $t('userConfiguration.messages.noDepositoSelected') }}
            </span>
        </div>
    </div>
</template>

<script>
import UserConfigurationProvider from '../../modules/user-configuration/providers/UserConfigurationProvider'

export default {
    name: 'DepositoDisplay',
    data() {
        return {
            depositoNombre: null,
            loading: false
        }
    },
    mounted() {
        this.loadUserConfiguration()
        this._onUserConfigurationUpdated = () => this.loadUserConfiguration(true)
        this.$root.$on('userConfigurationUpdated', this._onUserConfigurationUpdated)
    },
    beforeDestroy() {
        this.$root.$off('userConfigurationUpdated', this._onUserConfigurationUpdated)
    },
    methods: {
        loadUserConfiguration(forceRefresh = false) {
            this.loading = true
            UserConfigurationProvider.getUserConfiguration(forceRefresh)
                .then((response) => {
                    if (response && response.data && response.data.userConfigurationGet) {
                        const config = response.data.userConfigurationGet
                        if (config.deposito && config.deposito.nombre) {
                            this.depositoNombre = config.deposito.nombre
                        } else {
                            this.depositoNombre = null
                        }
                    } else {
                        this.depositoNombre = null
                    }
                })
                .catch((error) => {
                    console.error('Error loading user configuration:', error)
                    this.depositoNombre = null
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style scoped>
.deposito-display {
    min-width: 150px;
}

.deposito-badge {
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 4px;
    white-space: nowrap;
    transition: all 0.3s ease;
}

.selected-badge {
    background-color: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(4px);
}

.warning-badge {
    background-color: rgba(255, 152, 0, 0.2);
    border: 1px solid rgba(255, 152, 0, 0.4);
    backdrop-filter: blur(4px);
}

.deposito-label {
    font-size: 0.75rem;
    font-weight: 600;
    margin-right: 6px;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.selected-badge .deposito-label {
    color: rgba(255, 255, 255, 0.9) !important;
}

.warning-badge .deposito-label {
    color: #ff9800 !important;
}

.deposito-value {
    font-size: 0.875rem;
    font-weight: 600;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.selected-badge .deposito-value {
    color: rgba(255, 255, 255, 1) !important;
}

.warning-badge .deposito-value {
    color: #ff9800 !important;
}

.deposito-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.selected-badge:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
}

.warning-badge:hover {
    background-color: rgba(255, 152, 0, 0.3);
    border-color: rgba(255, 152, 0, 0.5);
}
</style>

